import { Link, useLocation } from "react-router-dom";
import LogoMark from "./Logo";

export const Header = () => {
    const location = useLocation();
    const isLanding = location.pathname === "/";
    const isResult = location.pathname.startsWith("/result");

    return (
        <header
            data-testid="site-header"
            className="sticky top-0 z-50 border-b border-biks-line/60 bg-biks-bg/85 backdrop-blur-md"
        >
            <div className="mx-auto flex h-16 max-w-7xl items-center justify-between px-6 lg:px-10">
                <Link
                    to="/"
                    data-testid="brand-link"
                    className="group flex items-center gap-3"
                >
                    <LogoMark size={28} className="transition-transform group-hover:rotate-3" />
                    <span className="font-display text-lg font-bold tracking-tight text-white">
                        BoM
                    </span>
                    <span className="hidden text-[11px] font-medium uppercase tracking-[0.22em] text-biks-text2 sm:inline">
                        Break or Make
                    </span>
                </Link>
                <nav className="flex items-center gap-2">
                    <Link
                        to="/contact"
                        data-testid="header-contact-link"
                        className="hidden rounded-md border border-transparent px-4 py-2 text-sm text-biks-text2 transition-colors hover:text-white sm:inline-block"
                    >
                        Private review
                    </Link>
                    {!isLanding && isResult && (
                        <Link
                            to="/scan"
                            data-testid="header-restart-scan-link"
                            className="rounded-md border border-biks-line px-4 py-2 text-sm text-white transition-colors hover:border-biks-blue"
                        >
                            New scan
                        </Link>
                    )}
                    {isLanding && (
                        <Link
                            to="/scan"
                            data-testid="header-start-scan-link"
                            className="rounded-md bg-biks-blue px-4 py-2 text-sm font-semibold text-white transition-colors hover:bg-blue-500"
                        >
                            Start the free BoM scan
                        </Link>
                    )}
                </nav>
            </div>
        </header>
    );
};

export default Header;
